import { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function DispositionSelector({ callId, campaignId, onDispositionSet }) {
  const [codes, setCodes] = useState([]);
  const [selectedCode, setSelectedCode] = useState(null);
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCodes();
  }, [campaignId]);

  const fetchCodes = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(
        `${API_BASE}/dialer/campaigns/${campaignId}/disposition-codes`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCodes(response.data);
    } catch (error) {
      console.error('Error fetching disposition codes:', error);
    }
  };

  const handleSetDisposition = async () => {
    if (!selectedCode) return;
    
    setLoading(true);
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post(
        `${API_BASE}/dialer/calls/${callId}/disposition`,
        { disposition_code_id: selectedCode, notes },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onDispositionSet?.();
    } catch (error) {
      console.error('Error setting disposition:', error);
      alert('Failed to set disposition');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium">Disposition</label>
      <select
        value={selectedCode || ''}
        onChange={(e) => setSelectedCode(e.target.value)}
        className="w-full border rounded px-3 py-2"
      >
        <option value="">Select disposition...</option>
        {codes.map((code) => (
          <option key={code.id} value={code.id}>
            {code.label}
          </option>
        ))}
      </select>
      <textarea
        placeholder="Disposition notes (optional)"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        className="w-full border rounded px-3 py-2"
        rows={2}
      />
      <button
        onClick={handleSetDisposition}
        disabled={!selectedCode || loading}
        className="w-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:bg-gray-400"
      >
        {loading ? 'Setting...' : 'Set Disposition'}
      </button>
    </div>
  );
}


